<template>
  <v-layout elevation-7>
    <v-flex>
      <v-card v-if="model != null"
      >
        <v-parallax
          src="/static/images/lotte-card.JPG"
          height="150"
        >
          <v-layout
            align-center
            column
            justify-center
            class="lightbox2"
          >
            <h1 class="display-1 mb-1 s-card-title font-effect-3d-float">Lotte</h1>
            <h4
              style="width:100%; padding-left:10px; padding-right:10px;"
              class="subheading s-card-subtitle text-xs-center">{{ model.baseInfo.productName }}</h4>
          </v-layout>
        </v-parallax>

        <v-container
          id="grid"
          fluid
          grid-list-sm
          tag="section"
        >
          <v-layout wrap>
            <!--<v-flex class="subheading">상품정보</v-flex>-->
            <!--<v-flex xs12 order-xs0>-->
              <!--<v-layout column>-->
                <!--<v-flex>-->
                  <!--<v-card flat dark>-->
                    <!--<v-card-text>{{ "APPLE WATCH SERIES 3 (GPS 38MM) SPACE GRAY ALUMINIUM CASE WITH BLACK SPORT BAND" }}</v-card-text>-->
                  <!--</v-card>-->
                <!--</v-flex>-->
              <!--</v-layout>-->
            <!--</v-flex>-->
            <v-flex xs12 pl-2 pr-2>
              <label-text title="출발지" :text="model.baseInfo.departure"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12 pl-2 pr-2>
              <label-text title="도착지" :text="model.baseInfo.destination"></label-text>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-layout
          column
          fill-height
        >
          <v-container v-if="!hasResult" fill-height fluid>
            <v-layout column class="text-xs-center">
              <v-flex  >
                <h1 v-if="!hasResult" class="title">조회된 데이터가 없습니다</h1>
              </v-flex>
            </v-layout>
          </v-container>

          <v-flex>
            <template v-for="(item, index) in listReverse">
              <delivery-list-item v-bind:key="index"
                v-bind:title="item.status"
                v-bind:primary-chip="item.location"
                v-bind:green-chip="item.store == '-' ? '' : item.store"
                v-bind:date="item.date"></delivery-list-item>
              <v-divider v-if="index + 1 < model.list.length" :key="`divider-${index}`"></v-divider>
            </template>
          </v-flex>

        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import LabelText from '../LabelText'
import DeliveryListItem from '../DeliveryListItem'
export default {
  name: 'LotteGlobalLogisCard',
  props: ['model'],
  components: {LabelText, DeliveryListItem},
  computed: {
    hasResult: function () {
      return this.model.list.length > 0
    },
    listReverse: function () {
      return [...this.model.list].reverse()
    }
  }
}
</script>

<style scoped>
  .lightbox {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 80px);
  }
  .lightbox2 {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 100%);
    padding-left: 0px!important;
  }
  .info-table {
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/card/LotteGlobalLogisCard.vue